import * as React from "react"
import {
    HelperText, Label, StyledDiv, StyledSpan, TextAreaField, Wrapper
} from "./styles"
import {
    Error
} from "../styles"
import { TextAreaProps } from "./types"

const TextArea: React.FC<TextAreaProps> = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(({
    label,
    required,
    error,
    helperText,
    ...props
}, ref) => {
    return <div>
        <Wrapper>
            {label && <Label>
                {label}
                {" "}
                {required && <StyledSpan>*</StyledSpan>}
            </Label>}
            <TextAreaField rows={5} cols={60} ref={ref} {...props} />
        </Wrapper>
        {helperText && <HelperText>
            <StyledSpan>*</StyledSpan>
            <StyledDiv
                dangerouslySetInnerHTML={{ __html: String(helperText) }}
            />
        </HelperText>}
        {error && <Wrapper>
            <Error>{error}</Error>
        </Wrapper>}
    </div>
})

export default TextArea
